import { ActivatedRoute } from '@angular/router';
import { TabsContainerService, BaseTabsContainer, UserService } from 'yt-ng-framework';
import { Component, OnInit } from '@angular/core';
import { ResenjeZaGo } from './resenje-za-go';

@Component({
    selector: 'yt-resenje-za-go-tabs',
    templateUrl: './resenje-za-go-tabs.component.html',
    providers: [
        TabsContainerService
    ]
})
export class ResenjeZaGoTabsComponent 
extends BaseTabsContainer<ResenjeZaGo> 
implements OnInit {

     constructor(
      public tabsContainerService: TabsContainerService<ResenjeZaGo>,
      protected activatedRoute: ActivatedRoute,
      protected userService: UserService
    ) {
      super(tabsContainerService, activatedRoute, userService);
     }
  
    ngOnInit() {
      super.ngOnInit();
    }  

  }